import { ChangeDetectionStrategy, Component, inject, input, resource } from "@angular/core";

import { BlogListComponent } from "../blogs-list/blogs-list.component";
import { CardViewModel } from "../../models/card.vm";
import { CapabilitiesService, CapabilityViewModel } from "../../data/capabilities.service";
import { ICapabilityForm } from "@in2/models";

@Component({
    selector: "in2-our-capabilities-grid",
    imports: [BlogListComponent],
    templateUrl: "./our-capabilities-grid.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ["./our-capabilities-grid.component.scss"],
})
export class OurCapabilitiesGridComponent {
    private readonly capabilitiesService = inject(CapabilitiesService);

    count = input<number | null>(null);
    firstItemLink = input<CapabilityViewModel | null>(null);

    capabilitiesResource = resource({
        request: () => {
            const count = this.count();
            const fiL = this.firstItemLink();
            return { count, fiL };
        },
        loader: async ({ request }) => {
            const items = await this.capabilitiesService.list(request.fiL ? [request.fiL.slug] : []);

            const { count, fiL } = request;
            if (!items) return [];
            if (items.length < 1) return [];
            const c = items.map((c: ICapabilityForm) => mapToCardViewModel(c));

            return fiL
                ? [
                      {
                          img: null,
                          title: $localize`Discover More About Our Capabilities`,
                          meta: {
                              classList: "link-item",
                          },
                      },
                      ...c.slice(0, count ?? items.length),
                  ]
                : c;
        },
    });
}

function mapToCardViewModel(c: ICapabilityForm): CardViewModel {
    return {
        img: { src: c.image?.[0]?.path, alt: c.title, width: 500, height: 500 },
        title: c.title,
        description: c.description,
        slug: c.slug,
        link: `/capability/${c.slug}`,
        meta: {
            classList: "overlay",
        },
    };
}
